(function () {
  var root = document.querySelector('[data-cozylume-landing]');
  if (!root) return;

  var header = root.querySelector('[data-cl-header]');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setScrollVars() {
    var y = window.scrollY || window.pageYOffset || 0;
    root.style.setProperty('--scrollY', y.toFixed(0));
    if (header) header.classList.toggle('is-scrolled', y > 48);
  }

  setScrollVars();
  window.addEventListener('scroll', function () {
    window.requestAnimationFrame(setScrollVars);
  }, { passive: true });

  if ('IntersectionObserver' in window && !reducedMotion) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });

    root.querySelectorAll('.cl-reveal, .cl-stagger').forEach(function (el) {
      observer.observe(el);
    });
  } else {
    root.querySelectorAll('.cl-reveal, .cl-stagger').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }
})();
